/**
 * eslint-disable vue/multi-word-component-names
 *
 * @format
 */

/** @format */
import Scaffold from './components/Scaffold.vue'
import TitleBar from './components/TitleBar.vue'
import Column from './components/Column.vue'
import Row from './components/Row.vue'
import Text from './components/Text.vue'
import Button from './components/Button.vue'
import Dialog from './components/Dialog.vue'
import AlertContent from './components/AlertContent.vue'
import CommonAlert from './components/CommonAlert.vue'
import Box from './components/Box.vue'
import Avatar from './components/Avatar.vue'
import ImageView from './components/ImageView.vue'
import TabLayout from './components/TabLayout.vue'
import ViewPager from './components/ViewPager.vue'
import LoadingWidget from './components/LoadingWidget.vue'
import EmptyView from './components/EmptyView.vue'

// 活动ui全局组件
import QSection from './ui-runtime/core/components/base/q-section.vue'
import QButton from './ui-runtime/core/components/base/q-button.vue'

function registerComponent(app) {
  app
    .component('Scaffold', Scaffold)
    .component('Column', Column)
    .component('Row', Row)
    .component('Text', Text)
    .component('TitleBar', TitleBar)
    .component('AlertContent', AlertContent)
    .component('Dialog', Dialog)
    .component('Box', Box)
    .component('Avatar', Avatar)
    .component('ImageView', ImageView)
    .component('TabLayout', TabLayout)
    .component('ViewPager', ViewPager)
    .component('Button', Button)
    .component('LoadingWidget', LoadingWidget)
    .component('EmptyView', EmptyView)
    .component('CommonAlert', CommonAlert)
    .component('QSection', QSection)
    .component('QButton', QButton)
}
function registerDirective(app) {
  app.directive('statusbar', {
    mounted(el, binding, vnode, prevVnode) {
      el.style.height = `${25 / 3.75}vw`
      window.setupWebViewJavascriptBridge(bridge => {
        bridge.callHandler('ucoo_status_bar_height', JSON.stringify({}), result => {
          let resultData = JSON.parse(result)
          let height
          if (resultData.status == 0) {
            height = parseInt(resultData.data || '25')
          } else {
            height = 25
          }
          el.style.height = `${height / 3.75}vw`
        })
      })
    },
  })
  //将根元素字体大小设为设计稿的屏幕宽（375px）的375分之一，那么1rem就相当于设计稿的1px
  app.directive('density', {
    mounted(el, binding, vnode, prevVnode) {
      // console.log('density:',el)
      var width = document.documentElement.clientWidth || window.innerWidth
      console.log('density window width:', width)
      document.documentElement.style.fontSize = width / 375 + 'px'
    },
  })
  app.directive('bounce', {
    mounted(el, binding, vnode, prevVnode) {
      console.log('created bounce', el)
      el.animate([{ transform: 'scale(.8)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], {
        duration: 300,
        easing: 'linear',
      })
    },
  })
  //slide from bottom
  app.directive('slideup', {
    mounted(el, binding, vnode, prevVnode) {
      requestAnimationFrame(() => {
        el.animate([{ transform: 'translateY(100%)' }, { transform: 'translateY(0)' }], {
          duration: 300,
          easing: 'linear',
        })
      })
    },
  })
  app.directive('scalein', {
    mounted(el, binding, vnode, prevVnode) {
      requestAnimationFrame(() => {
        el.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.1)' }, { transform: 'scale(1)' }], {
          duration: 200,
          // overshot
          easing: 'ease-in',
        })
      })
    },
  })
  app.directive('slidein', {})
  app.directive('fadein', {
    mounted(el, binding, vnode, prevVnode) {
      console.log('created fadein', el)
      requestAnimationFrame(() => {
        el.animate([{ opacity: 0 }, { opacity: 1 }], {
          duration: 300,
          easing: 'linear',
        })
      })
    },
  })
  app.directive('screenbg', {
    created(el, binding, vnode, prevVnode) {
      // 下面会介绍各个参数的细节
      console.log('==========created:', vnode, binding)
    },
  })
  app.directive('useScreenHeight', {
    created(el, binding, vnode, prevVnode) {
      // 下面会介绍各个参数的细节
      vnode.el.style.minHeight = window.innerHeight + 'px'
    },
  })
}

export { registerDirective, registerComponent }
